import { useMemo } from 'react';
import { client } from './client';

type ChangePasswordBody = {
  current_password: string;
  new_password: string;
};

export function useChangePassword() {
  async function changePassword(payload: ChangePasswordBody): Promise<void> {
    const { error } = await client.POST('/password/change/', {
      body: payload,
    });
    if (error) throw error as any;
  }

  const memoized = useMemo(() => ({ changePassword }), []);
  return memoized;
}


